/* eslint-disable react-hooks/exhaustive-deps */
// Vendor
import { memo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

// Components
import Button, {
  ButtonColor,
  ButtonSize,
  ButtonType,
  ButtonVariant
} from 'src/components/atoms/Button';
import { Icon } from 'src/components/atoms/Icon';
import InputText, { InputTextType } from 'src/components/atoms/InputText/InputText';
import { SearchContainer } from '../styles';

// Types
import { CheckboxType } from 'src/components/atoms/Checkbox/types';
import usePrevious from 'src/hooks/usePrevious';
import { listProps } from '../types';

const isDisabledInputSearch = (
  list: listProps,
  data: CheckboxType[],
  searchText: string,
  prevSearchText: string
) => {
  if (list.hasError) return true;
  if (data.length === 0 && list.data.length === 0) {
    if (searchText.length === 0 && prevSearchText.length > 0) return false;
    return searchText.length === 0;
  }
};

const isDisabledButtonSearch = (
  list: listProps,
  data: CheckboxType[],
  searchText: string,
  prevSearchText: string,
  minLength: number
) => {
  if (list.hasError) return true;
  if (searchText.length > 0 && data.length === 0 && list.data.length === 0) return false;
  if (searchText.length === 0 && prevSearchText.length > 0) return false;
  if (searchText.length < minLength) return true;
};

const SearchBox = ({
  list,
  data,
  placeholder,
  onSearch,
  minLength = 1
}: {
  list: listProps;
  data: CheckboxType[];
  placeholder?: string;
  onSearch: (content: string | null) => void;
  minLength?: number;
}) => {
  const inputName = `inputSearch_${list.name}`;

  const methods = useForm({
    mode: 'onSubmit'
  });

  const [refresh, setRefresh] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const prevInputValue = usePrevious(inputValue);

  const onSubmit = (data: { [x: string]: string }) => {
    onSearch(data[inputName]);
  };

  const handleKeyDown = (event: { key: string }) => {
    if (
      event.key === 'Enter' &&
      !isDisabledButtonSearch(list, data, inputValue, prevInputValue || '', minLength)
    ) {
      methods.handleSubmit(onSubmit)();
    }
  };

  return (
    <FormProvider {...methods} key={`${list.name}__${refresh}`}>
      <SearchContainer>
        <InputText
          name={`inputSearch_${list.name}`}
          placeholder={placeholder || 'Search'}
          showLabel={false}
          showOptionalLabel={false}
          type={InputTextType.text}
          isDisabled={isDisabledInputSearch(list, data, inputValue, prevInputValue || '')}
          onChange={(e) => {
            setInputValue(e.value.toString());
          }}
          onKeyDown={handleKeyDown}
          endAndorment={
            inputValue && (
              <Button
                onClick={() => {
                  onSearch('');
                  setInputValue('');

                  methods.setValue(inputName, '');
                  methods.setFocus(inputName);

                  setRefresh(!refresh);
                }}
                label={`remove search of ${list.name}`}
                className="end-andorment"
                name={`close_button__${list.name}`}
                variant={ButtonVariant.ghost}
                type={ButtonType.button}
              >
                <Icon icon="icon-close" />
              </Button>
            )
          }
        />
        <Button
          name={`search_button__${list.name}`}
          className="search_button"
          color={ButtonColor.primary}
          variant={ButtonVariant.contained}
          size={ButtonSize.medium}
          isLoading={false}
          isDisabled={isDisabledButtonSearch(
            list,
            data,
            inputValue,
            prevInputValue || '',
            minLength
          )}
          type={ButtonType.button}
          onClick={methods.handleSubmit(onSubmit)}
        >
          <Icon icon="icon-search" />
        </Button>
      </SearchContainer>
    </FormProvider>
  );
};

export default memo(SearchBox);
